import { render, staticRenderFns } from "./SlideUpMenu.vue?vue&type=template&id=bc0b7564&scoped=true&"
import script from "./SlideUpMenu.vue?vue&type=script&lang=js&"
export * from "./SlideUpMenu.vue?vue&type=script&lang=js&"
import style0 from "./SlideUpMenu.vue?vue&type=style&index=0&id=bc0b7564&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc0b7564",
  null
  
)

export default component.exports